import { render, staticRenderFns } from "./WithdrawsData.vue?vue&type=template&id=f6771004"
import script from "./WithdrawsData.vue?vue&type=script&lang=js"
export * from "./WithdrawsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports